module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av531-2ec66a757b8e9a0ee6c3a133d78a751c.jpg";